import { styled } from '@mui/system';
import { FC, useEffect, useState } from 'react';
import { useIcon } from '../../Hooks/useIcon';

interface DocumentTitleProps {
  bgColor?: string;
  textColor?: string;
  iconColor?: string;
  iconBackground?: string;
  padding?: number;
  icon: string;
  title: string;
  documentLink?: string;
}

const RootDiv = styled('div')({
  marginTop: '20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '& .doc-title-outer-bg': {
    borderRadius: '50px',
    padding: '10px 20px',
    display: 'flex',
    alignItems: 'center',
  },
  '& .title-icon': {
    fontSize: '32px',
    padding: '11px 15px 11px',
    borderRadius: '50%',
  },
  '& .title-text': {
    fontSize: '48px',
    marginLeft: '10px',
    marginBottom: '10px',
    fontWeight: 200,
    lineHeight: '50px',
    wordBreak: 'break-all',
  },
  '& .is-link': {
    textDecoration: 'none',
  },

  '& .is-link:hover': {
    textDecoration: 'underline',
  },
});

const DocumentTitle: FC<DocumentTitleProps> = (props) => {
  const [Style, setStyle] = useState<any>({
    padding: 10,
    titleType: 'document',
  });

  const [BGColor, setBGColor] = useState<any>(props.bgColor);
  const [TextColor, setTextColor] = useState<any>(props.textColor);
  const [IconColor, setIconColor] = useState<any>(props.iconColor);
  const [IconBGColor, setIconBGColor] = useState<any>(props.iconBackground);

  useEffect(() => {
    setBGColor(props.bgColor);
    setTextColor(props.textColor);
    setIconColor(props.iconColor);
    setIconBGColor(props.iconBackground);

    setStyle({ padding: props.padding });
    // eslint-disable-next-line
  }, [
    props.iconColor,
    props.iconBackground,
    props.bgColor,
    props.textColor,
    props.icon,
    props.padding,
  ]);

  return (
    <RootDiv>
      <a
        href={props.documentLink}
        className={`doc-title-outer-bg link-title ${
          props.documentLink ? 'is-link' : ''
        }`}
        onClick={(e) => {
          if (!props.documentLink) {
            e.preventDefault();
          }
        }}
        style={{
          backgroundColor: BGColor,
          padding: Style.padding,
          textDecoration: props.documentLink ? 'underline' : 'none',
          cursor: props.documentLink ? 'pointer' : 'initial',
        }}
      >
        <div className="title-icon" style={{ backgroundColor: IconBGColor }}>
          <TitleIcon color={IconColor} iconName={props.icon} />
        </div>
        <div className="title-text" style={{ color: TextColor }}>
          {props.title}
        </div>
      </a>
    </RootDiv>
  );
};

export default DocumentTitle;

interface TitleIconProps {
  color?: string;
  iconName: string;
}

const TitleIcon: FC<TitleIconProps> = (props) => {
  const Icon = useIcon(props);
  return <>{Icon}</>;
};
